import { get } from '.';

export function GetVehicleModelDefinitions(options = {}) {
	return get<any>("/app/api/vehicle_model_definitions", options);
}

export function GetDistinctVehicleModels(options = {}) {
	return get<any>("/app/api/vehicle_model_definitions/distinct", options);
}